import commonConstant from '../../common/_commonConstant';

export const getParkingStatus = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PARKING_STATUS_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PARKING_STATUS_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getParkingStatusById = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PARKING_STATUS_BY_ID_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PARKING_STATUS_BY_ID_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createParking = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_PARKING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_PARKING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const carExit = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_STATUS_CAR_EXIT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_STATUS_CAR_EXIT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
